import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import redirectToMiniprogram from '@src/utils/h5-redirect-to-miniprogram';
import { MINI_PROGRAM_CONFIG } from '@src/constants/business';

class AppointmentModalStore extends BaseModalStore {
  appointmentByPhone = noop;

  constructor(options = {}) {
    super();
    const { appointmentByPhone = noop, ...rest } = options;
    this.appointmentByPhone = () => {
      this.onClickClose();
      appointmentByPhone();
    };
    Object.assign(this, rest);
  }

  appointmentByMiniprogram = () => {
    redirectToMiniprogram({ ...MINI_PROGRAM_CONFIG });
  };

  use() {
    super.use();
  }
}

export default AppointmentModalStore;
